//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { CampaignType } from '@apis/campaigns/campaignsApiModel';
import { IAliasedDateRange } from '@components/date-range-picker/dateRangePickerModels';
import DateString from '@models/DateString';
import TimeZoneId from '@models/TimeZoneId';

interface IGenerateCampaignFilename {
  campaignType: CampaignType;
  campaignName: string;
  dateRange: IAliasedDateRange;
  extension?: string;
}

export function generateCampaignFilename({
  campaignType,
  campaignName,
  dateRange,
  extension = 'zip',
}: IGenerateCampaignFilename) {
  const endDate =
    dateRange.startDate !== dateRange.endDate ? `_${dateRange.endDate}` : '';
  const timeStr = `${dateRange.startDate}${endDate}`;

  return `campaigns_${campaignType}_${campaignName
    .split(' ')
    .join('-')}_${timeStr}.${extension}`;
}

export function getFullCampaignDateRange({
  start,
  end,
  userTimeZoneId,
}: {
  start: DateString;
  end: DateString;
  userTimeZoneId: TimeZoneId;
}): IAliasedDateRange {
  return {
    displayName: 'Full Campaign Duration',
    startDate: getCampaignMaxDate(start, userTimeZoneId),
    endDate: getCampaignMaxDate(end, userTimeZoneId),
    timeZone: userTimeZoneId,
  };
}

/**
 * Get the maximum date that is not in the future. If the passed date is in the future,
 * then default to now
 *
 */
export function getCampaignMaxDate(
  date: DateString,
  userTimeZoneId: TimeZoneId,
) {
  const now = DateString.fromTimestamp(new Date(), userTimeZoneId);

  return DateString.compare(date, now) > 0 ? now : date;
}
